import React from "react"
import PropTypes from "prop-types"

import image from "shared/images/package-icon.png"

import styles from "./Error.css"


const DesktopError = ({ number }, { t: translate }) => (
  <tr key={`error_${number}`} className="notfound">
    <td>{number}</td>
    <td>
      <div className={styles.img}>
        <img src={image} alt="No trace for this parcel" />
      </div>
      {translate("No trace for this parcel")}
    </td>
    <td colSpan="3" className="fs-12">
      <span className="textUnderlined">{translate("The reasons can be:")}</span>
      {" "}
      {translate("the number you have entered is incorrect or the number of the consignment letter has not been entered into the system yet - please try on the next day after posting an order.")}
    </td>
  </tr>
)

DesktopError.propTypes = {
  number: PropTypes.string.isRequired,
}
DesktopError.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default DesktopError



// WEBPACK FOOTER //
// ./src/views/Parcels/components/ParcelsList/ParcelsListTableDesktop/components/Error/Error.js